import React from 'react';

import './style/style.scss';

import logoWebmotorsWhite from './images/logo-web-branco.svg';

const Thanks = () => (
	<div className="container-component-thanks">
		<div className="content">
			<img src={logoWebmotorsWhite} alt="Logo Webmotors branca" width={354} height={78} />

			<h2 className="block-text">
				Obrigado! <br />
				<strong>boas vendas</strong>
			</h2>

			<a href="./briefings" className="btn btn-outline-white">VOLTAR PARA MEUS BRIEFINGS</a>
		</div>
	</div>
);

export default Thanks;
